export default {"src":"/_next/static/media/Bread 1.f87873b7.svg","height":57,"width":61,"blurWidth":0,"blurHeight":0};